var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgChats = function SvgChats(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    "data-width-12": 9,
    "data-width-16": 12,
    "data-width-20": 15,
    "data-width-24": 18,
    "data-width-28": 21,
    "data-width-72": 53,
    viewBox: "0 0 8.8 8.7",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M.87 8.65A.875.875 0 0 1 0 7.755V1.15A1.155 1.155 0 0 1 1.15 0H7.6a1.155 1.155 0 0 1 1.15 1.15v4.645a1.15 1.15 0 0 1-1.15 1.15H3.165l-1.69 1.5a.88.88 0 0 1-.605.205m.255-7.9a.4.4 0 0 0-.4.4v6.605a.135.135 0 0 0 .085.13.13.13 0 0 0 .15-.025l1.795-1.57a.4.4 0 0 1 .25-.095h4.57a.4.4 0 0 0 .4-.4V1.15a.4.4 0 0 0-.4-.4zM3.34 4.185h-.5a.375.375 0 1 1 0-.75h.5a.375.375 0 0 1 0 .75m2.08 0h.5a.375.375 0 0 0 0-.75h-.5a.375.375 0 0 0 0 .75",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgChats);
export default ForwardRef;